// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { sampleGraphs } from '../../components/InteractiveMap/config/sample-graphs';

// Use the SOLUTIONS array below to override or add information to your solutions. This can be useful for development
// purposes, but it is recommended to leave this array empty and use the API to update your Solution instead for
// production environments.
export const SOLUTIONS = [
  // Note: This is a temporary solution for providing default map content.
  // TODO: This should be replaced with proper loading from scenario dataset in the future.
  // The SOLUTIONS array below is used to override or add information to solutions.
  // For production environments, it is recommended to use the API to update Solutions instead.
  {
    id: 'interactiveMap',
    parameters: [
      {
        id: 'interactiveMap',
        varType: 'string',
        defaultValue: sampleGraphs.emergencyProcedure,
      },
    ],
  },
];
